import { fromJS } from "immutable";
import ACTIONS, { FETCH_STATUS } from "../constants";

const initialState = fromJS({
  selectedParticipant: {},
  loading: false,
  error: "",
  participantUpdateReceivedByPusher: null,
});

export default function ParticpantReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.RESET_SELECTED_PARTICIPANT: {
      return state.set("selectedParticipant", {});
    }
    case ACTIONS.GET_PARTICIAPNT.PENDING: {
      return state.set("loading", action.status === FETCH_STATUS.LOADING);
    }
    case ACTIONS.GET_PARTICIAPNT.SUCCESS: {
      const complianceItems = action.data.participant_compliance_items || [];
      const hasMandatoryComplianceDocuments = complianceItems.some(
        (item) => item.type === "document" && item.is_compliance
      );
      const participant = {
        ...action.data.participant,
        has_mandatory_compliance_documents: hasMandatoryComplianceDocuments,
      };
      const participantTasks =
        participant?.tasks ?? participant?.participant_tasks ?? [];
      const quickSnapshot = state.getIn([
        "selectedParticipant",
        "participantQuickSnapshot",
      ]);
      const plainQuickSnapshot =
        quickSnapshot && typeof quickSnapshot.toJS === "function"
          ? quickSnapshot.toJS()
          : quickSnapshot;
      const updatedQuickSnapshot = plainQuickSnapshot
        ? {
            ...plainQuickSnapshot,
            tasks: participantTasks,
            participant_tasks: participantTasks,
          }
        : plainQuickSnapshot;

      return state
        .set("loading", false)
        .set("error", "")
        .setIn(["selectedParticipant", "participant"], participant)
        .setIn(
          ["selectedParticipant", "participantOnBoarding"],
          action.data.on_boarding_progress
        )
        .setIn(
          ["selectedParticipant", "participantComplianceItems"],
          complianceItems
        )
        .setIn(
          ["selectedParticipant", "participantQuickSnapshot"],
          updatedQuickSnapshot
        );
    }
    case ACTIONS.GET_PARTICIAPNT.ERROR: {
      return state.set("loading", false).set("error", action);
    }
    case ACTIONS.RE_SET_PARTICIAPNT: {
      return state
        .set("loading", false)
        .set("error", "")
        .setIn(["selectedParticipant", "participant"], action.data.participant)
        .setIn(
          ["selectedParticipant", "participantOnBoarding"],
          action.data.participantOnBoarding
        );
    }
    case ACTIONS.GET_PARTICIPANT_SUPPORT_PLAN.PENDING: {
      return state.setIn(
        ["selectedParticipant", "fetchSupportPlanLoading"],
        action.status === FETCH_STATUS.LOADING
      );
    }
    case ACTIONS.GET_PARTICIPANT_SUPPORT_PLAN.SUCCESS: {
      return state
        .setIn(["selectedParticipant", "fetchSupportPlanLoading"], false)
        .setIn(["selectedParticipant", "fetchSupportPlanError"], "")
        .setIn(
          ["selectedParticipant", "participantSupportPlan"],
          action.data.data
        );
    }
    case ACTIONS.GET_PARTICIPANT_SUPPORT_PLAN.ERROR: {
      return state
        .setIn(["selectedParticipant", "fetchSupportPlanLoading"], false)
        .setIn(["selectedParticipant", "fetchSupportPlanError"], action);
    }

    case ACTIONS.PARTICIPANT_QUICK_SNAPSHOT.PENDING: {
      return state
        .setIn(["selectedParticipant", "fetchQuickSnapshotLoading"], true)
        .setIn(["selectedParticipant", "fetchQuickSnapshotError"], "");
    }
    case ACTIONS.PARTICIPANT_QUICK_SNAPSHOT.SUCCESS: {
      return state
        .setIn(["selectedParticipant", "fetchQuickSnapshotLoading"], false)
        .setIn(["selectedParticipant", "fetchQuickSnapshotError"], "")
        .setIn(
          ["selectedParticipant", "participantQuickSnapshot"],
          action.data.data
        );
    }
    case ACTIONS.PARTICIPANT_QUICK_SNAPSHOT.ERROR: {
      return state
        .setIn(["selectedParticipant", "fetchQuickSnapshotLoading"], false)
        .setIn(["selectedParticipant", "fetchQuickSnapshotError"], action);
    }

    case ACTIONS.PARTICIPANT_SETTING_UPDATE.PENDING: {
      return state
        .setIn(["selectedParticipant", "updateSettingLoading"], true)
        .setIn(["selectedParticipant", "updateSettingError"], "");
    }
    case ACTIONS.PARTICIPANT_SETTING_UPDATE.SUCCESS: {
      const responseData =
        action.data?.data ?? action.data?.participant ?? action.data;
      const participantData =
        responseData?.data && typeof responseData.data === "object"
          ? responseData.data
          : responseData;
      const quickSnapshot = state.getIn([
        "selectedParticipant",
        "participantQuickSnapshot",
      ]);
      const plainQuickSnapshot =
        quickSnapshot && typeof quickSnapshot.toJS === "function"
          ? quickSnapshot.toJS()
          : quickSnapshot;
      const resolvedTasks =
        participantData?.tasks ??
        participantData?.participant_tasks ??
        plainQuickSnapshot?.tasks ??
        plainQuickSnapshot?.participant_tasks;
      const updatedQuickSnapshot = plainQuickSnapshot
        ? {
            ...plainQuickSnapshot,
            xero_invoice_reference:
              participantData?.xero_invoice_reference ?? null,
            ndis_no: participantData?.ndis_no ?? plainQuickSnapshot.ndis_no,
            tasks: resolvedTasks,
            participant_tasks: resolvedTasks,
            ...(participantData?.family_app_enabled !== undefined
              ? {
                  family_app_enabled: participantData.family_app_enabled,
                }
              : {}),
            ...(participantData?.shift_req_allow !== undefined
              ? { shift_req_allow: participantData.shift_req_allow }
              : {}),
            ...(participantData?.participant_app_enabled !== undefined
              ? {
                  participant_app_enabled:
                    participantData.participant_app_enabled,
                }
              : {}),
            ...(participantData?.pt_shift_req_allow !== undefined
              ? {
                  pt_shift_req_allow: participantData.pt_shift_req_allow,
                }
              : {}),
          }
        : plainQuickSnapshot;

      return state
        .setIn(["selectedParticipant", "updateSettingLoading"], false)
        .setIn(["selectedParticipant", "updateSettingError"], "")
        .setIn(["selectedParticipant", "participant"], {
          ...participantData,
        })
        .setIn(
          ["selectedParticipant", "participantQuickSnapshot"],
          updatedQuickSnapshot
        );
    }
    case ACTIONS.PARTICIPANT_SETTING_UPDATE.ERROR: {
      return state
        .setIn(["selectedParticipant", "updateSettingLoading"], false)
        .setIn(["selectedParticipant", "updateSettingError"], action);
    }

    case ACTIONS.PARTICIPANT_APPOINTMENT_LIST.PENDING: {
      return state
        .setIn(["selectedParticipant", "appiontmentsLoading"], true)
        .setIn(["selectedParticipant", "appiontmentsError"], "");
    }
    case ACTIONS.PARTICIPANT_APPOINTMENT_LIST.SUCCESS: {
      return state
        .setIn(["selectedParticipant", "appiontmentsLoading"], false)
        .setIn(["selectedParticipant", "appiontmentsError"], "")
        .setIn(
          ["selectedParticipant", "participantAppointments"],
          action.data.participant_appointments
        );
    }
    case ACTIONS.PARTICIPANT_APPOINTMENT_LIST.ERROR: {
      return state
        .setIn(["selectedParticipant", "appiontmentsLoading"], false)
        .setIn(["selectedParticipant", "appiontmentsError"], action);
    }

    case ACTIONS.PARTICIPANT_APPOINTMENT_CREATE.PENDING: {
      return state
        .setIn(["selectedParticipant", "createAppiontmentsLoading"], true)
        .setIn(["selectedParticipant", "createAppiontmentsError"], "");
    }
    case ACTIONS.PARTICIPANT_APPOINTMENT_CREATE.SUCCESS: {
      const appointments =
        state.getIn(["selectedParticipant", "participantAppointments"]) || [];
      appointments.unshift({ ...action.data.participant_appointments });
      return state
        .setIn(["selectedParticipant", "createAppiontmentsLoading"], false)
        .setIn(["selectedParticipant", "createAppiontmentsError"], "")
        .setIn(
          ["selectedParticipant", "participantAppointments"],
          [...appointments]
        );
    }
    case ACTIONS.PARTICIPANT_APPOINTMENT_CREATE.ERROR: {
      return state
        .setIn(["selectedParticipant", "createAppiontmentsLoading"], false)
        .setIn(["selectedParticipant", "createAppiontmentsError"], action);
    }

    case ACTIONS.PARTICIPANT_APPOINTMENT_UPDATE.PENDING: {
      return state
        .setIn(["selectedParticipant", "createAppiontmentsLoading"], true)
        .setIn(["selectedParticipant", "createAppiontmentsError"], "");
    }
    case ACTIONS.PARTICIPANT_APPOINTMENT_UPDATE.SUCCESS: {
      const appointments =
        state.getIn(["selectedParticipant", "participantAppointments"]) || [];
      if (appointments && appointments.length > 0) {
        const index = appointments.findIndex(
          (x) => x.uuid === action.data.uuid
        );
        if (index !== -1) {
          appointments.splice(index, 1, { ...action.data });
        }
      }
      return state
        .setIn(["selectedParticipant", "createAppiontmentsLoading"], false)
        .setIn(["selectedParticipant", "createAppiontmentsError"], "")
        .setIn(
          ["selectedParticipant", "participantAppointments"],
          [...appointments]
        );
    }
    case ACTIONS.PARTICIPANT_APPOINTMENT_UPDATE.ERROR: {
      return state
        .setIn(["selectedParticipant", "createAppiontmentsLoading"], false)
        .setIn(["selectedParticipant", "createAppiontmentsError"], action);
    }

    case ACTIONS.PARTICIPANT_APPOINTMENT_DELETE_LOCALLY: {
      const appointments =
        state.getIn(["selectedParticipant", "participantAppointments"]) || [];
      if (appointments && appointments.length > 0) {
        const index = appointments.findIndex(
          (x) => x.id === action.data.appointmentId
        );
        if (index !== -1) {
          appointments.splice(index, 1);
        }
      }
      return state.setIn(
        ["selectedParticipant", "participantAppointments"],
        [...appointments]
      );
    }

    case ACTIONS.SUBMITTED_FORM_UPDATE_PT_PERCENTAGE_LOCALLY: {
      const prevParticipant =
        state.getIn(["selectedParticipant", "participant"]) || null;
      if (
        prevParticipant &&
        action.data &&
        "on_boarding_progress_percentage" in action.data
      ) {
        Object.assign(prevParticipant, {
          on_boarding_progress: action.data.on_boarding_progress_percentage,
        });
      }
      const prevOnBoarding =
        state.getIn(["selectedParticipant", "participantOnBoarding"]) || null;
      if (
        prevOnBoarding &&
        action.data &&
        "on_boarding_progress" in action.data
      ) {
        Object.assign(prevOnBoarding, {
          ...action.data.on_boarding_progress,
        });
      }
      return state
        .setIn(["selectedParticipant", "participant"], { ...prevParticipant })
        .setIn(
          ["selectedParticipant", "participantOnBoarding"],
          [...prevOnBoarding]
        );
    }

    case ACTIONS.PARTICIPANT_UPDATE_PUSHER_RECEIVED: {
      return state.set("participantUpdateReceivedByPusher", action.data);
    }

    case ACTIONS.RESET_PARTICIPANT_UPDATE_PUSHER: {
      return state.set("participantUpdateReceivedByPusher", null);
    }

    default: {
      return state;
    }
  }
}
